import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrderLineAgent, SalesAgentsCommissionDetails, SalesOrderLine } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class OrderLineAgentService extends TmsWebBaseEditCreateService<SalesOrderLine, OrderLineAgent> {
  constructor() {
    super('OrderLineAgent', $localize`Order Line Agent`);
  }

  getForSalesOrderLine(id: string): Observable<OrderLineAgent[]> {
    return this.httpService.get<OrderLineAgent[]>(`${this.apiUrl}/GetForSalesOrderLine?id=${id}`);
  }

  getSalesAgentsCommission(fromDate: Date, toDate: Date): Observable<SalesAgentsCommissionDetails[]> {
    return this.httpService.get<SalesAgentsCommissionDetails[]>(
      `${this.apiUrl}/SalesAgentsCommission?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
    );
  }
}
